/** Libellé compact pour les modes de paiement référentiel (code + nom). */
export function formatPaymentMethodLabel(method: {
  code?: string | null;
  name: string;
}): string {
  const code = method.code?.trim();
  if (code) return `${code} — ${method.name}`;
  return method.name;
}

/** Règlement commande : paiement immédiat vs différé (évite la confusion Comptant / En compte). */
export const PAYMENT_SETTLEMENT_IMMEDIATE_LABEL = "Immédiat";
export const PAYMENT_SETTLEMENT_LATER_LABEL = "Plus tard";

export function formatPaymentSettlementLabel(isImmediate: boolean): string {
  return isImmediate ? PAYMENT_SETTLEMENT_IMMEDIATE_LABEL : PAYMENT_SETTLEMENT_LATER_LABEL;
}
